function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "computer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M106.963 279H262.8C264.894 279 266.902 279.738 268.383 281.053C269.864 282.367 270.696 284.15 270.696 286.009V377.294H99.0692V286.008C99.0693 284.15 99.901 282.368 101.381 281.053C102.861 279.739 104.869 279 106.963 279V279Z",
  fill: "#D2DCE6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M106.963 279H262.8C264.894 279 266.902 279.738 268.383 281.053C269.864 282.367 270.696 284.15 270.696 286.009V377.294H99.0692V286.008C99.0693 284.15 99.901 282.368 101.381 281.053C102.861 279.739 104.869 279 106.963 279V279Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M258.239 366.372V290.604H112.218V366.372H258.239Z",
  fill: "#FF5C5C"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  opacity: 0.3,
  d: "M197.339 354.085H221.561",
  stroke: "white",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  opacity: 0.3,
  d: "M255.507 330.852C255.969 330.827 256.427 330.94 256.808 331.175C257.189 331.41 257.47 331.753 257.606 332.147V327.428C257.099 327.296 256.574 327.227 256.046 327.225H255.507C254.345 327.225 253.765 327.743 253.765 328.78V329.334C253.765 330.334 254.345 330.852 255.507 330.852Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  opacity: 0.3,
  d: "M257.606 353.475C257.467 353.868 257.185 354.208 256.805 354.441C256.424 354.674 255.967 354.786 255.507 354.76C254.345 354.76 253.765 355.279 253.765 356.315V356.87C253.765 357.906 254.346 358.424 255.507 358.424H256.046C256.574 358.422 257.099 358.354 257.606 358.222V353.475Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M258.239 366.372V290.604H112.218V366.372H258.239Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M80.8391 377.976H289.618C290.105 377.976 290.573 378.146 290.918 378.448C291.263 378.751 291.457 379.161 291.457 379.588V381.519C291.457 383.657 290.488 385.708 288.764 387.219C287.039 388.731 284.7 389.58 282.261 389.58H88.1953C85.7565 389.58 83.4177 388.731 81.6932 387.219C79.9688 385.708 79 383.657 79 381.519V379.588C79 379.161 79.1938 378.751 79.5386 378.448C79.8835 378.146 80.3513 377.976 80.8391 377.976Z",
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_9",
  d: "M282.26 385.811H88.1934C85.9884 385.81 83.8575 385.087 82.1895 383.773C80.5216 382.46 79.4279 380.645 79.108 378.659C79.0388 378.833 79.0023 379.017 79 379.203V381.208C79 383.429 79.9688 385.558 81.6932 387.128C83.4177 388.698 85.7565 389.58 88.1953 389.58H282.261C284.7 389.58 287.039 388.698 288.764 387.128C290.488 385.558 291.457 383.429 291.457 381.208V379.203C291.454 379.017 291.418 378.833 291.349 378.659C291.029 380.646 289.935 382.461 288.266 383.775C286.597 385.088 284.465 385.811 282.26 385.811V385.811Z",
  fill: "#CFD1D0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_10",
  d: "M80.8391 377.976H289.618C290.105 377.976 290.573 378.146 290.918 378.448C291.263 378.751 291.457 379.161 291.457 379.588V381.519C291.457 383.657 290.488 385.708 288.764 387.219C287.039 388.731 284.7 389.58 282.261 389.58H88.1953C85.7565 389.58 83.4177 388.731 81.6932 387.219C79.9688 385.708 79 383.657 79 381.519V379.588C79 379.161 79.1938 378.751 79.5386 378.448C79.8835 378.146 80.3513 377.976 80.8391 377.976Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_11",
  d: "M165.505 377.294H204.26C204.26 378.38 203.871 379.421 203.179 380.189C202.486 380.958 201.548 381.389 200.569 381.389H169.196C168.217 381.389 167.278 380.958 166.586 380.189C165.894 379.421 165.505 378.38 165.505 377.294Z",
  fill: "#686B6D"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_12",
  d: "M165.505 377.294H204.26C204.26 378.38 203.871 379.421 203.179 380.189C202.486 380.958 201.548 381.389 200.569 381.389H169.196C168.217 381.389 167.278 380.958 166.586 380.189C165.894 379.421 165.505 378.38 165.505 377.294Z",
  stroke: "#283035",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_13",
  d: "M184.882 287.874C187.176 287.874 189.035 286.499 189.035 284.802C189.035 283.106 187.176 281.73 184.882 281.73C182.589 281.73 180.73 283.106 180.73 284.802C180.73 286.499 182.589 287.874 184.882 287.874Z",
  fill: "#686B6D"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_14",
  d: "M184.882 287.874C187.176 287.874 189.035 286.499 189.035 284.802C189.035 283.106 187.176 281.73 184.882 281.73C182.589 281.73 180.73 283.106 180.73 284.802C180.73 286.499 182.589 287.874 184.882 287.874Z",
  stroke: "#283035",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_15",
  d: "M296.993 389.58C297.014 386.496 298.408 383.545 300.871 381.371C303.335 379.197 306.668 377.976 310.142 377.976C313.616 377.976 316.949 379.197 319.412 381.371C321.876 383.545 323.27 386.496 323.291 389.58H296.993Z",
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_16",
  d: "M310.488 386.167C312.381 386.183 314.256 385.833 315.987 385.139C317.718 384.446 319.264 383.425 320.523 382.146C319.281 380.838 317.741 379.788 316.009 379.068C314.277 378.349 312.394 377.976 310.488 377.976C308.582 377.976 306.698 378.349 304.967 379.068C303.235 379.788 301.695 380.838 300.453 382.146C301.712 383.425 303.258 384.446 304.989 385.139C306.72 385.833 308.595 386.183 310.488 386.167V386.167Z",
  fill: "#CFD1D0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_17",
  d: "M296.993 389.58C297.014 386.496 298.408 383.545 300.871 381.371C303.335 379.197 306.668 377.976 310.142 377.976C313.616 377.976 316.949 379.197 319.412 381.371C321.876 383.545 323.27 386.496 323.291 389.58H296.993Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_18",
  opacity: 0.3,
  d: "M240.671 348.955C240.671 347.326 239.965 346.179 238.555 345.476C237.56 344.995 237.146 344.624 237.146 343.774V342.332C237.146 341.333 237.643 341.11 238.514 340.592C239.965 340.037 240.671 338.853 240.671 337.077V333.931C240.671 331.414 241.707 329.563 243.2 328.786C244.317 328.075 245.644 327.676 247.015 327.639H247.554C248.715 327.639 249.296 328.157 249.296 329.193V329.746C249.296 330.745 248.716 331.264 247.554 331.264C245.939 331.264 245.149 332.3 245.149 334.409V338.295C245.19 339.239 244.927 340.173 244.39 340.986C243.854 341.8 243.066 342.459 242.122 342.885L241.749 342.995V343.07C242.174 343.182 242.569 343.371 242.91 343.625C243.947 344.179 245.149 345.475 245.149 347.733V352.063C245.149 354.135 245.937 355.172 247.554 355.172C248.715 355.172 249.296 355.69 249.296 356.726V357.281C249.296 358.317 248.716 358.835 247.554 358.836H247.015C245.644 358.798 244.317 358.399 243.2 357.688C241.707 356.911 240.671 355.024 240.671 352.544V348.955Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  id: "Vector_19",
  d: "M106.963 279H262.8C264.894 279 266.902 279.738 268.383 281.053C269.864 282.367 270.696 284.15 270.696 286.009V377.294H99.0692V286.008C99.0693 284.15 99.901 282.368 101.381 281.053C102.861 279.739 104.869 279 106.963 279V279Z",
  fill: "#D2DCE6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_20",
  d: "M106.963 279H262.8C264.894 279 266.902 279.738 268.383 281.053C269.864 282.367 270.696 284.15 270.696 286.009V377.294H99.0692V286.008C99.0693 284.15 99.901 282.368 101.381 281.053C102.861 279.739 104.869 279 106.963 279V279Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_21",
  d: "M258.239 366.372V290.604H112.218V366.372H258.239Z",
  fill: "#FF5C5C"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_22",
  opacity: 0.3,
  d: "M197.339 354.085H221.561",
  stroke: "white",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_23",
  opacity: 0.3,
  d: "M255.507 330.852C255.969 330.827 256.427 330.94 256.808 331.175C257.189 331.41 257.47 331.753 257.606 332.147V327.428C257.099 327.296 256.574 327.227 256.046 327.225H255.507C254.345 327.225 253.765 327.743 253.765 328.78V329.334C253.765 330.334 254.345 330.852 255.507 330.852Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_24",
  opacity: 0.3,
  d: "M257.606 353.475C257.467 353.868 257.185 354.208 256.805 354.441C256.424 354.674 255.967 354.786 255.507 354.76C254.345 354.76 253.765 355.279 253.765 356.315V356.87C253.765 357.906 254.346 358.424 255.507 358.424H256.046C256.574 358.422 257.099 358.354 257.606 358.222V353.475Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  id: "Vector_25",
  d: "M258.239 366.372V290.604H112.218V366.372H258.239Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_26",
  d: "M184.882 287.874C187.176 287.874 189.035 286.499 189.035 284.802C189.035 283.106 187.176 281.73 184.882 281.73C182.589 281.73 180.73 283.106 180.73 284.802C180.73 286.499 182.589 287.874 184.882 287.874Z",
  fill: "#686B6D"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_27",
  d: "M184.882 287.874C187.176 287.874 189.035 286.499 189.035 284.802C189.035 283.106 187.176 281.73 184.882 281.73C182.589 281.73 180.73 283.106 180.73 284.802C180.73 286.499 182.589 287.874 184.882 287.874Z",
  stroke: "#283035",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_28",
  d: "M296.993 389.58C297.014 386.496 298.408 383.545 300.871 381.371C303.335 379.197 306.668 377.976 310.142 377.976C313.616 377.976 316.949 379.197 319.412 381.371C321.876 383.545 323.27 386.496 323.291 389.58H296.993Z",
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_29",
  d: "M310.488 386.167C312.381 386.183 314.256 385.833 315.987 385.139C317.718 384.446 319.264 383.425 320.523 382.146C319.281 380.838 317.741 379.788 316.009 379.068C314.277 378.349 312.394 377.976 310.488 377.976C308.582 377.976 306.698 378.349 304.967 379.068C303.235 379.788 301.695 380.838 300.453 382.146C301.712 383.425 303.258 384.446 304.989 385.139C306.72 385.833 308.595 386.183 310.488 386.167V386.167Z",
  fill: "#CFD1D0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_30",
  d: "M296.993 389.58C297.014 386.496 298.408 383.545 300.871 381.371C303.335 379.197 306.668 377.976 310.142 377.976C313.616 377.976 316.949 379.197 319.412 381.371C321.876 383.545 323.27 386.496 323.291 389.58H296.993Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "terminal"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_31",
  d: "M195.901 300.754H125.781C123.741 300.754 122.087 302.215 122.087 304.018V352.098C122.087 353.901 123.741 355.362 125.781 355.362H195.901C197.941 355.362 199.595 353.901 199.595 352.098V304.018C199.595 302.215 197.941 300.754 195.901 300.754Z",
  fill: "#353F49"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_32",
  d: "M195.901 300.754H125.781C123.741 300.754 122.087 302.215 122.087 304.018V352.098C122.087 353.901 123.741 355.362 125.781 355.362H195.901C197.941 355.362 199.595 353.901 199.595 352.098V304.018C199.595 302.215 197.941 300.754 195.901 300.754Z",
  stroke: "#283035",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_33",
  d: "M125.781 300.754H195.901C196.88 300.754 197.82 301.071 198.513 301.635C199.206 302.199 199.595 302.963 199.595 303.761V308.263H122.087V303.761C122.087 302.963 122.476 302.199 123.168 301.635C123.861 301.071 124.801 300.754 125.781 300.754Z",
  fill: "#EAEEEF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_34",
  d: "M125.781 300.754H195.901C196.88 300.754 197.82 301.071 198.513 301.635C199.206 302.199 199.595 302.963 199.595 303.761V308.263H122.087V303.761C122.087 302.963 122.476 302.199 123.168 301.635C123.861 301.071 124.801 300.754 125.781 300.754Z",
  stroke: "#283035",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_35",
  opacity: 0.35,
  d: "M127.969 305.532C128.924 305.532 129.699 305.074 129.699 304.509C129.699 303.943 128.924 303.485 127.969 303.485C127.013 303.485 126.239 303.943 126.239 304.509C126.239 305.074 127.013 305.532 127.969 305.532Z",
  fill: "#283035"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_36",
  opacity: 0.35,
  d: "M132.813 305.532C133.769 305.532 134.543 305.074 134.543 304.509C134.543 303.943 133.769 303.485 132.813 303.485C131.858 303.485 131.083 303.943 131.083 304.509C131.083 305.074 131.858 305.532 132.813 305.532Z",
  fill: "#283035"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_37",
  opacity: 0.35,
  d: "M136.965 305.532C137.539 305.532 138.003 305.074 138.003 304.509C138.003 303.943 137.539 303.485 136.965 303.485C136.392 303.485 135.927 303.943 135.927 304.509C135.927 305.074 136.392 305.532 136.965 305.532Z",
  fill: "#283035"
})), /*#__PURE__*/React.createElement("g", {
  id: "commands"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_38",
  d: "M130.962 317.618H136.498",
  stroke: "#46BB86",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_39",
  d: "M137.882 317.618H151.723",
  stroke: "#46BB86",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_40",
  d: "M130.962 321.031H151.723",
  stroke: "#389ABE",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_41",
  d: "M135.806 325.126H145.495",
  stroke: "#E5C689",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_42",
  d: "M147.571 325.126H157.952",
  stroke: "#F2F3F4",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_43",
  d: "M141.343 327.857H162.104",
  stroke: "#F2F3F4",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_44",
  d: "M141.343 331.27H156.567",
  stroke: "#FFA49F",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_45",
  d: "M135.806 334.683H157.952",
  stroke: "#F2F3F4",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_46",
  d: "M130.962 337.413H143.419",
  stroke: "#389ABE",
  strokeWidth: 3,
  strokeMiterlimit: 10
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_47",
  opacity: 0.3,
  d: "M240.671 348.955C240.671 347.326 239.965 346.179 238.555 345.476C237.56 344.995 237.146 344.624 237.146 343.774V342.332C237.146 341.333 237.643 341.11 238.514 340.592C239.965 340.037 240.671 338.853 240.671 337.077V333.931C240.671 331.414 241.707 329.563 243.2 328.786C244.317 328.075 245.644 327.676 247.015 327.639H247.554C248.715 327.639 249.296 328.157 249.296 329.193V329.746C249.296 330.745 248.716 331.264 247.554 331.264C245.939 331.264 245.149 332.3 245.149 334.409V338.295C245.19 339.239 244.927 340.173 244.39 340.986C243.854 341.8 243.066 342.459 242.122 342.885L241.749 342.995V343.07C242.174 343.182 242.569 343.371 242.91 343.625C243.947 344.179 245.149 345.475 245.149 347.733V352.063C245.149 354.135 245.937 355.172 247.554 355.172C248.715 355.172 249.296 355.69 249.296 356.726V357.281C249.296 358.317 248.716 358.835 247.554 358.836H247.015C245.644 358.798 244.317 358.399 243.2 357.688C241.707 356.911 240.671 355.024 240.671 352.544V348.955Z",
  fill: "white"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "platform"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_48",
  d: "M391.235 395H403",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_49",
  d: "M74.2803 395H385.699",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_50",
  d: "M18.917 395H68.7439",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_51",
  d: "M3 395H14.0727",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Vector_52",
  d: "M183.907 205.096C190.213 205.096 195.325 200.664 195.325 195.198C195.325 189.732 190.213 185.3 183.907 185.3C177.6 185.3 172.488 189.732 172.488 195.198C172.488 200.664 177.6 205.096 183.907 205.096Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Vector_53",
  d: "M151.569 196.904C151.002 196.903 150.443 196.795 149.926 196.589C149.41 196.382 148.95 196.081 148.575 195.706C148.2 195.331 147.92 194.89 147.753 194.412C147.586 193.935 147.535 193.431 147.605 192.935C149.771 176.713 165.043 164.14 183.561 164.14C202.079 164.14 217.351 176.713 219.516 192.935C219.586 193.431 219.536 193.935 219.368 194.413C219.201 194.89 218.921 195.331 218.546 195.707C218.171 196.082 217.71 196.382 217.194 196.589C216.678 196.795 216.118 196.903 215.551 196.904H151.569Z",
  fill: "#F7B66F"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Vector_54",
  d: "M151.599 196.904C151.028 196.903 150.464 196.795 149.944 196.587C149.424 196.379 148.96 196.076 148.582 195.698C148.205 195.321 147.922 194.877 147.754 194.396C147.586 193.914 147.535 193.407 147.605 192.908C149.786 176.697 165.053 164.14 183.561 164.14C202.07 164.14 217.337 176.697 219.516 192.908C219.586 193.407 219.536 193.914 219.367 194.396C219.199 194.877 218.916 195.321 218.539 195.699C218.161 196.076 217.697 196.379 217.177 196.587C216.657 196.795 216.093 196.903 215.522 196.904H151.599Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "cable",
  d: "M183.561 1L182.869 165.505",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "drink"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_56",
  d: "M44.7578 335.113L48.408 319.823L67.5952 316",
  stroke: "#283035",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_57",
  d: "M31.791 393.816H54.2625C55.042 393.816 55.7948 393.563 56.3799 393.105C56.9649 392.647 57.342 392.015 57.4406 391.327L63.4429 349.447H22.6124L28.6152 391.327C28.7137 392.014 29.0905 392.646 29.6751 393.104C30.2596 393.562 31.0119 393.815 31.791 393.816V393.816Z",
  fill: "#EAD57D"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_58",
  d: "M31.791 393.816H54.2625C55.042 393.816 55.7948 393.563 56.3799 393.105C56.9649 392.647 57.342 392.015 57.4406 391.327L63.4429 349.447H22.6124L28.6152 391.327C28.7137 392.014 29.0905 392.646 29.6751 393.104C30.2596 393.562 31.0119 393.815 31.791 393.816V393.816Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_59",
  d: "M61.9213 381.529L64.827 361.051H21.2284L24.1341 381.529H61.9213Z",
  fill: "#5CBF84"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_60",
  d: "M20.0262 349.447H66.0291C68.805 349.447 71.0554 347.308 71.0554 344.669C71.0554 342.03 68.805 339.891 66.0291 339.891H20.0262C17.2503 339.891 15 342.03 15 344.669C15 347.308 17.2503 349.447 20.0262 349.447Z",
  fill: "#5CBF84"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_61",
  d: "M20.0262 349.447H66.0291C68.805 349.447 71.0554 347.308 71.0554 344.669C71.0554 342.03 68.805 339.891 66.0291 339.891H20.0262C17.2503 339.891 15 342.03 15 344.669C15 347.308 17.2503 349.447 20.0262 349.447Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_62",
  d: "M24.6886 339.891H61.3668L60.641 335.113H25.4148L24.6886 339.891Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "smile"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_63",
  d: "M29.5329 372.811L30.4609 371.973C33.9826 374.622 38.3783 376.068 42.9117 376.068C47.445 376.068 51.8407 374.622 55.3624 371.973L56.5225 373.025",
  stroke: "#283035",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_64",
  d: "M39.9135 368.976C39.9135 368.504 39.7312 368.05 39.4068 367.716C39.0823 367.382 38.6423 367.195 38.1834 367.195V367.195C37.7245 367.195 37.2845 367.382 36.96 367.716C36.6356 368.05 36.4533 368.504 36.4533 368.976V370.608",
  stroke: "#283035",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_65",
  d: "M45.4498 368.976C45.4498 368.504 45.6686 368.05 46.0579 367.716C46.4473 367.382 46.9753 367.195 47.526 367.195V367.195C48.0766 367.195 48.6046 367.382 48.994 367.716C49.3833 368.05 49.6021 368.504 49.6021 368.976V370.608",
  stroke: "#283035",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "Vector_66",
  d: "M61.9213 381.529L64.827 361.051H21.2284L24.1341 381.529H61.9213Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "todolist"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_67",
  d: "M388.595 373.956C388.181 373.182 387.888 372.334 387.728 371.447C387.319 369.17 388.328 367.868 387.782 366.572C387.565 366.055 387.46 365.349 385.827 365.082",
  stroke: "#283035",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_68",
  d: "M376.092 340.509H340.198C337.88 340.509 336 342.177 336 344.236V390.024C336 392.082 337.88 393.751 340.198 393.751H376.092C378.411 393.751 380.291 392.082 380.291 390.024V344.236C380.291 342.177 378.411 340.509 376.092 340.509Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_69",
  d: "M365.527 337.45H361.836V336.236C361.836 335.378 361.447 334.555 360.755 333.948C360.063 333.341 359.124 333 358.145 333C357.166 333 356.228 333.341 355.535 333.948C354.843 334.555 354.454 335.378 354.454 336.236V337.45H350.764C349.785 337.45 348.846 337.79 348.154 338.397C347.462 339.004 347.073 339.827 347.073 340.686C347.073 341.544 347.462 342.367 348.154 342.974C348.846 343.581 349.785 343.922 350.764 343.922H365.527C366.506 343.922 367.445 343.581 368.137 342.974C368.829 342.367 369.218 341.544 369.218 340.686C369.218 339.827 368.829 339.004 368.137 338.397C367.445 337.79 366.506 337.45 365.527 337.45Z",
  fill: "#F7B66F"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_70",
  d: "M365.527 337.45H361.836V336.236C361.836 335.378 361.447 334.555 360.755 333.948C360.063 333.341 359.124 333 358.145 333C357.166 333 356.228 333.341 355.535 333.948C354.843 334.555 354.454 335.378 354.454 336.236V337.45H350.764C349.785 337.45 348.846 337.79 348.154 338.397C347.462 339.004 347.073 339.827 347.073 340.686C347.073 341.544 347.462 342.367 348.154 342.974C348.846 343.581 349.785 343.922 350.764 343.922H365.527C366.506 343.922 367.445 343.581 368.137 342.974C368.829 342.367 369.218 341.544 369.218 340.686C369.218 339.827 368.829 339.004 368.137 338.397C367.445 337.79 366.506 337.45 365.527 337.45Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_71",
  d: "M358.145 355.526C360.056 355.526 361.606 354.15 361.606 352.454C361.606 350.757 360.056 349.382 358.145 349.382C356.234 349.382 354.685 350.757 354.685 352.454C354.685 354.15 356.234 355.526 358.145 355.526Z",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_72",
  d: "M343.612 363.717H352.609",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_73",
  d: "M343.612 373.956H352.609",
  stroke: "#283035",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_74",
  d: "M358.837 362.536L361.264 365.764L368.526 360.304",
  stroke: "#8BAFC1",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_75",
  d: "M358.837 373.861L361.264 376.686L368.526 371.908",
  stroke: "#8BAFC1",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_76",
  d: "M384.957 363.43L380.385 363.997L384.457 390.114L389.03 389.546L384.957 363.43Z",
  fill: "#3BBC88"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_77",
  d: "M384.957 363.43L380.385 363.997L384.457 390.114L389.03 389.546L384.957 363.43Z",
  stroke: "#283035",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_78",
  d: "M383.268 359.281L380.525 359.622L381.163 363.701L383.905 363.36L383.268 359.281Z",
  stroke: "#283035",
  strokeWidth: 3.99829,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 183.907,
  y1: 191.308,
  x2: 183.907,
  y2: 407.593,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.093,
  stopColor: "white",
  stopOpacity: 0.864
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.284,
  stopColor: "white",
  stopOpacity: 0.605
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.466,
  stopColor: "white",
  stopOpacity: 0.389
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.633,
  stopColor: "white",
  stopOpacity: 0.221
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.784,
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.911,
  stopColor: "white",
  stopOpacity: 0.026
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 401,
    viewBox: "0 0 406 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, _ref4, _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M326.813 400.317H41L147.832 194.174H219.981L326.813 400.317Z",
    fill: "url(#paint0_linear)"
  })), _ref8, _ref9), _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3a667491.svg";
export { ForwardRef as ReactComponent };